import React, { FC, useState } from 'react';
import { Modal, ModalContent, Portal, Loader } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { OPTIMIZED_IMAGE_WIDTH_MOBILE, OPTIMIZED_IMAGE_WIDTH_DESKTOP } from 'common/constants';
import { loader, displayNone } from 'common/styles';
import { useOptimisedImages } from '@navi-toolbox/hooks';
import { image } from './styles';

export const DATA_QA_STORE_PLAN_MODAL_IMAGE = 'store-plan-modal-image';
export const DATA_QA_STORE_PLAN_MODAL_IMAGE_SOURCE = 'store-plan-modal-image-source';

type Props = {
  show: boolean;
  onClose: () => void;
  imageUrl: string;
};

export const StorePlanModal: FC<Props> = ({ show, onClose, imageUrl }) => {
  const { mobile } = useBreakpoints() ?? {};
  const [isLoading, setIsLoading] = useState(true);

  const optimizedImage = useOptimisedImages({
    src: imageUrl,
    sizes: {
      rest: {
        w: mobile ? OPTIMIZED_IMAGE_WIDTH_MOBILE : OPTIMIZED_IMAGE_WIDTH_DESKTOP,
      },
    },
  });

  const optimizedImageUrl = optimizedImage.rest?.x ?? undefined;

  const onLoad = () => {
    setIsLoading(false);
  };

  return (
    <Portal>
      <Modal onClose={onClose} size="s" variant="full-screen" data-qa="store-plan-modal" show={show}>
        {isLoading && <Loader size="m" className={loader} />}
        <ModalContent className={isLoading ? displayNone : ''}>
          <picture>
            <source
              srcSet={`${optimizedImage.rest?.xx} 2x, ${optimizedImage.rest?.x} 1x`}
              data-qa={DATA_QA_STORE_PLAN_MODAL_IMAGE_SOURCE}
            />
            <img
              src={optimizedImageUrl}
              alt="План магазина"
              className={image}
              data-qa={DATA_QA_STORE_PLAN_MODAL_IMAGE}
              onLoad={onLoad}
            />
          </picture>
        </ModalContent>
      </Modal>
    </Portal>
  );
};
